import {
  DatePickerField,
  RadioGroupField,
  TextAreaField,
} from 'components/Molecules/FormFields/index';
import React from 'react';
import { Button, Tag, Modal } from 'antd';
import get from 'lodash/get';
import { useFormikContext } from 'formik';
import T from 'i18n-react';
import classes from './SubForm.module.scss';
import { NS } from '../../constants';
import { QMASDocumentContext } from '../../context';

export default function DateAndReminder() {
  const formikProps = useFormikContext();
  const { setFieldValue } = formikProps;
  const { readonly, shouldDisabledField } = React.useContext(QMASDocumentContext);
  const [modal, contextHolder] = Modal.useModal();

  const showConfirmClearAllSettings = () => {
    modal.confirm({
      title: T.translate(`${NS}.clearAllSettings`),
      content: T.translate(`${NS}.allSettingInThePopupWillBeCleared`),
      okText: T.translate(`${NS}.clear`),
      cancelText: T.translate(`${NS}.cancel`),
      cancelButtonProps: { hidden: true },
      onOk() {
        setFieldValue('reminder', {
          issueDate: null,
          expiryDate: null,
          reviewDate: null,
          reminderType: null,
          reminderDate: null,
          note: '',
        });
      },
    });
  };

  const showConfirmClearReminder = () => {
    setFieldValue('reminder.reminderType', null);
    setFieldValue('reminder.reminderDate', null);
    setFieldValue('reminder.note', null);
  };

  return (
    <div className={classes.dateAndReminder}>
      <DatePickerField
        name="reminder.issueDate"
        label={T.translate(`${NS}.issueDate`)}
        format="DD MMM YY"
        disabled={
          shouldDisabledField
            ? shouldDisabledField(
                {
                  name: 'reminder.issueDate',
                  value: get(formikProps.values, 'reminder.issueDate'),
                },
                {
                  form: formikProps,
                  readonly,
                }
              )
            : readonly
        }
      />
      <DatePickerField
        name="reminder.expiryDate"
        label={T.translate(`${NS}.expiryDate`)}
        format="DD MMM YY"
        disabled={readonly}
        onChange={({ field, form }, mValue) => {
          const { values } = form;
          const { reminder } = values;
          field.onChange({
            target: {
              name: field.name,
              value: mValue,
            },
          });
          if (!reminder.reviewDate && mValue) {
            form.setFieldValue('reminder.reviewDate', mValue.clone().subtract(7, 'days'));
          }
        }}
      />
      <DatePickerField
        name="reminder.reviewDate"
        label={T.translate(`${NS}.reviewDate`)}
        format="DD MMM YY"
        disabled={readonly}
      />
      <RadioGroupField
        layoutClasses={classes.fieldLayout}
        name="reminder.reminderType"
        disabled={readonly}
        label={
          <>
            {T.translate(`${NS}.emailReminder`)}
            <span style={{ flexGrow: 1, textAlign: 'right' }}>
              <Button
                disabled={readonly}
                className={classes.clearReminder}
                size="small"
                type="link"
                onClick={showConfirmClearReminder}>
                {T.translate(`${NS}.clearReminderOption`)}
              </Button>
            </span>
          </>
        }
        options={[
          {
            label: T.translate(`${NS}.onExpiryDate`),
            value: 'onExpiryDate',
            shouldDisabled: (_option, { form }) => {
              if (readonly) return true;
              const { values } = form;
              const expiryDate = get(values, 'reminder.expiryDate');
              return !expiryDate;
            },
          },
          {
            label: T.translate(`${NS}.onReviewDate`),
            value: 'onReviewDate',
            shouldDisabled: (_option, { form }) => {
              if (readonly) return true;
              const { values } = form;
              const expiryDate = get(values, 'reminder.reviewDate');
              return !expiryDate;
            },
          },
          {
            label: T.translate(`${NS}.custom`),
            value: 'onCustomDate',
            shouldDisabled: () => {
              if (readonly) return true;
              return false;
            },
          },
        ]}
      />
      <DatePickerField
        name="reminder.reminderDate"
        format="DD MMM YY"
        disabled={readonly}
        showWhen={({ form }) => {
          const { values } = form;
          const emailReminder = get(values, 'reminder.reminderType');
          return ['onCustomDate'].includes(emailReminder);
        }}
      />
      <TextAreaField
        disabled={readonly}
        showWhen={({ form }) => {
          const { values } = form;
          const emailReminder = get(values, 'reminder.reminderType');
          return !!emailReminder;
        }}
        hasFeedback
        help={
          <Tag className={classes.helperText} color="processing">
            {T.translate(`${NS}.noteWillBeSentTogetherWithReminderEmail`)}
          </Tag>
        }
        name="reminder.note"
        label={T.translate(`${NS}.note`)}
        autoSize={{
          minRows: 3,
          maxRows: 3,
        }}
      />
      <Button
        disabled={readonly}
        className={classes.clearSetting}
        type="primary"
        danger
        ghost
        onClick={showConfirmClearAllSettings}>
        {T.translate(`${NS}.clearAllSettings`)}
      </Button>
      {contextHolder}
    </div>
  );
}
